import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { isPartialDate } from 'neuro-utils';
import { formatPartialDate } from 'Utility/date';
import { TDocument } from '../utils';
import { sortDocuments } from '../../../utility/randomUtil';
import TileContentMaker from 'Components/DashboardTile/TileContentMaker';
import { useAppSelector } from 'Store/index';

const fm = (id: string, values?: { [key: string]: string }): React.JSX.Element => (
  <FormattedMessage id={id} values={values || {}} />
);

const DiagnosticSurveyDash = ({ documents }: IOwnProps): React.JSX.Element => {
  const myDocs =
    useAppSelector((s: IState) => s.myapp.sortedAndMergedDocuments)?.filter(
      d => d._type === 'fbimod' || d._type === 'iadl',
    ) ?? [];

  const docs = documents?.filter(d => !['diagnosis', 'mmse'].includes(d._type));

  const comparator = sortDocuments([{ type: 'date', sortField: 'date' }]);
  const sortedDocs = docs.concat(myDocs).sort(comparator);

  return (
    <React.Fragment>
      <TileContentMaker
        type="recentList"
        data={sortedDocs.map(d => ({
          date: isPartialDate(d.date) ? formatPartialDate(d.date) : '',
          title: fm(`diagnosticSurvey.${d._type}.title`),
          key: d._id,
        }))}
      />
    </React.Fragment>
  );
};

interface IOwnProps {
  documents: Array<TDocument | IDiagnosis | IMMSE>;
}

export default DiagnosticSurveyDash;
